export default "__VITE_ASSET__BOrETRwX__"